<script>

    export let modalS = {
        status: false,
        id: 0,
        value: null,
        resolve: null,
        reject: null,
        mostrar: () => {
            modalS.status = true;
            return new Promise((resolve, reject) => {
                modalS.resolve = resolve;
                modalS.reject = reject;
            });
        },

        confirmar: (item) => {            
            modalS.resolve(item);
            modalS.status = false;
        },
        info: {
            title: "",
            body: "",
        },
        controllers: {
            btnClose: true,
            btn: [
                {
                    text: "Aceptar",
                    status: true,
                    style: "btn-success",
                    value: true,
                },
                {
                    text: "Cancelar",
                    status: true,
                    style: "btn-secondary",
                    value: false,
                },
            ],
            input: {
                status: false,
                placeholder: "",
                value: "",
                label: "",
            },
        },
    };

    export function Setinfo(datablock) {
        modalS.info = datablock; 
    }

    export function Setactivebtn(btnClose,btntrue,btnfalse) {
        modalS.controllers.btnClose = btnClose; 
        modalS.controllers.btn[0].status = btntrue; 
        modalS.controllers.btn[1].status = btnfalse; 
    }

        export function Settextbtn(btntrue,btnfalse) {

        modalS.controllers.btn[0].text = btntrue; 
        modalS.controllers.btn[1].text = btnfalse; 
    }

    export async function activeModal() {
        return modalS.mostrar();
    }







</script>

{#if modalS.status}
    <div
        class="modal"
        id="sampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="sampleModalLabel"
        aria-hidden={false}
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="sampleModalLabel">
                        {modalS.info.title}
                    </h5>
                    {#if modalS.controllers.btnClose}
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            on:click={() => (modalS.status = false)}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    {/if}
                </div>
                <div class="modal-body">{modalS.info.body}</div>
                {#if modalS.controllers.input.status}
                    <form action="">
                        <input
                            class="form-control"
                            type="text"
                            placeholder={modalS.controllers.input.placeholder}
                            aria-label="default input example"
                            bind:value={modalS.controllers.input.value}
                        />
                    </form>
                    <label for="input">{modalS.controllers.input.label}</label>
                {/if}
                <div class="modal-footer">
                    {#each modalS.controllers.btn as btn}
                        {#if btn.status}
                            <button
                                type="button"
                                class="btn {btn.style}"
                                data-dismiss="modal"
                                on:click={() => modalS.confirmar(btn.value)}
                                >{btn.text}</button
                            >
                        {/if}
                    {/each}
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop show" />
{/if}




<style>
  .modal {
    display: block;
  }
</style>
